import { css, cx } from "@emotion/css";
import { Divider } from "@octopusdeploy/design-system-components";
import { space, text, themeTokens, colorScales, borderRadius } from "@octopusdeploy/design-system-tokens";
import type { ReactElement } from "react";
import React, { Fragment } from "react";
import { useMediaQuery } from "react-responsive";
import type { PageHeaderPrimaryLogo } from "./PageHeaderPrimary";
export interface LeadingSegmentProps {
    logo?: PageHeaderPrimaryLogo;
    title: string;
    titleIcon?: ReactElement;
    titleChips?: ReactElement[];
}
export function LeadingSegment({ logo, title, titleIcon, titleChips }: LeadingSegmentProps) {
    const isLargerThanIpad = useMediaQuery({ query: `(min-width: 811px)` });
    return (<div className={cx(leadingSegmentStyles, { [leadingSegmentMobileStyles]: !isLargerThanIpad })}>
            {logo && (<div className={logoContainerStyles}>
                    <img className={logoStyles} src={logo.href} alt={logo.accessibleName}/>
                </div>)}
            <h2 title={title} className={titleStyles}>
                {title}
            </h2>
            {isLargerThanIpad && titleIcon}
            {titleChips && (<div className={cx(chipsWrapperStyles, { [chipsWrapperMobileStyles]: !isLargerThanIpad })}>
                    {isLargerThanIpad && <Divider orientation={"vertical"}/>}
                    {titleChips.map((chip, index) => (<Fragment key={index}>{chip}</Fragment>))}
                </div>)}
        </div>);
}
const leadingSegmentStyles = css({
    minWidth: 0,
    display: "flex",
    alignItems: "center",
    gap: space["12"],
});
const leadingSegmentMobileStyles = css({
    gap: space["16"],
    flexWrap: "wrap",
});
const logoContainerStyles = css({
    width: "2.25rem",
    height: "2.25rem",
    borderRadius: borderRadius.medium,
    display: "flex",
    flexShrink: 0,
    justifyContent: "center",
    background: colorScales.white,
});
const logoStyles = css({
    borderRadius: borderRadius.small,
    objectFit: "scale-down",
    width: "100%",
    height: "100%",
});
const titleStyles = css({
    all: "unset",
    flex: "1",
    maxWidth: "35rem",
    font: text.interface.heading.small,
    color: themeTokens.color.text.primary,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
});
const chipsWrapperStyles = css({
    display: "flex",
    gap: space["12"],
});
const chipsWrapperMobileStyles = css({
    flexBasis: "100%",
});
